import { Component, OnInit } from '@angular/core';
import { AuthService } from 'src/app/shared/services/auth.service';
import { CamaraComercioEntry } from 'src/app/shared/entrys/camara-comercio';
import { EstablecimientoComercioService } from '../../../prestador/establecimiento-comercio/establecimiento-comercio.service';
import { DatoAdjuntoModel } from 'src/app/shared/models/dato-adjunto.model';
import { AlertsService } from 'src/app/shared/services/alerts.service';
import { SolicitudService } from '../../../prestador/solicitudes/solicitud.service';
import { environment } from 'src/environments/environment';
import { RolesUsuario } from 'src/app/shared/enumeraciones/roles-usuario.enum';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { ConfiguracionCamaraService } from './configuracion-camara.service';
import { HttpEventType } from '@angular/common/http';
import { ResponseServiceModel } from 'src/app/shared/models/response-service.model';
import { AlertType } from 'src/app/shared/models/alert.model';
import { EnviromentGlobalService } from 'src/app/shared/services/enviroment-global.service';
import { forkJoin } from 'rxjs';


@Component({
  selector: 'app-configuracion-camara',
  templateUrl: './configuracion-camara.component.html',
  styleUrls: ['./configuracion-camara.component.scss']
})
export class ConfiguracionCamaraComponent implements OnInit {
  extensiones = ['image/jpg', 'image/x-png', 'image/png', 'image/jpeg'];
  userLogin: boolean;
  nombreFirmaAuxiliar: string;
  formFirma!: FormGroup;
  logoUrl: string;
  logo_camara_file: File;
  firma_file: File;
  firmaUrl: string;
  rutaAmazon;
  dataLogo: any;
  dataFirma: any;
  formCamara: FormGroup;
  adminSuper = RolesUsuario.AdministradorSuper;
  camarasLista: Array<CamaraComercioEntry>;
  tipoContenido = {
    logo: 1,
    firma: 2
  };
  constructor(
    public authService: AuthService, private enviromentGlobalService: EnviromentGlobalService,
    private establecimientoComercioService: EstablecimientoComercioService, private alertService: AlertsService,
    private solicitudService: SolicitudService, private formBuilder: FormBuilder, private configurarCamara: ConfiguracionCamaraService) {
    this.dataLogo = {};
    this.dataFirma = {};
    this.userLogin = authService.isToken();
    this.rutaAmazon = enviromentGlobalService.amazonImage;
  }
  ngOnInit() {
    if (this.authService.getRolUser(RolesUsuario.AdministradorCC)) {
      this.createFirmaForm();
      this.consultaLogoFirma();
    } else {
      
      this.createForm();
      this.createFirmaForm();
      this.establecimientoComercioService.getCamaras().subscribe(resultado => {
        if (resultado) {
          this.camarasLista = resultado.data as Array<CamaraComercioEntry>;
        }
      });
    }
  }
  createFirmaForm(): void{
    this.formFirma = this.formBuilder.group({
      nombre_firma: [null]
    });
  }
  createForm() {
    this.formCamara = this.formBuilder.group({
      codigo_camara: [null, [Validators.required]],
    });
  }
  consultaLogoFirma() {
    this.dataFirma = {};
    this.dataLogo = {};
    this.logoUrl = null;
    this.firmaUrl = null;
    this.solicitudService.getCamara({
      codigo_camara: this.authService.getRolUser(RolesUsuario.AdministradorCC) ?
        this.authService.getCamaraUser() : this.formCamara.value.codigo_camara
      , contenido_certificado_id: 'LOGO_CAMARA'
    }).subscribe(resultado => {
      if (resultado.result) {
        if (resultado.data && /[.]/.exec(resultado.data.nombre_archivo)) {
          // tslint:disable-next-line:max-line-length
          this.logoUrl = `${this.rutaAmazon}/${resultado.data.ruta}/${resultado.data.nombre_archivo}?dummy=${Math.floor(Math.random() * (9999 * 1000)) + 1000}`;
          this.dataLogo = resultado.data;
        } else {
          this.dataLogo = {};
          this.formFirma.get('nombre_firma').setValue(null);
        }

      }
    });
    forkJoin(
      {
        rutaFirma: this.solicitudService.getCamara({
          codigo_camara: this.authService.getRolUser(RolesUsuario.AdministradorCC) ?
            this.authService.getCamaraUser() : this.formCamara.value.codigo_camara
          , contenido_certificado_id: 'FIRMA_RESPONSABLE_CERTIFICADO'
        }),
        fileFirma: this.solicitudService.getCamaraFile({
          codigo_camara: this.authService.getRolUser(RolesUsuario.AdministradorCC) ?
            this.authService.getCamaraUser() : this.formCamara.value.codigo_camara
          , contenido_certificado_id: 'FIRMA_RESPONSABLE_CERTIFICADO'
          , descargar_contenido: true
        })
      }
    ).subscribe(resultado => {
      if (resultado.rutaFirma.result) {
        if (resultado.rutaFirma.data && /[.]/.exec(resultado.rutaFirma.data.nombre_archivo)) {
          this.dataFirma = resultado.rutaFirma.data;
          this.nombreFirmaAuxiliar = this.dataFirma.nombre_firma;
          this.formFirma.get('nombre_firma').setValue(this.dataFirma.nombre_firma);
        } else {
          this.dataFirma = {};
        }

      }

      if (resultado.fileFirma) {
        const urlCreator = window.URL || window.webkitURL;
        const imageUrl = urlCreator.createObjectURL(resultado.fileFirma);
        this.firmaUrl = imageUrl;
      }
    });
  }

  onFileInput(eventFile, flag) {
    const tempo = eventFile.target.files as FileList;
    const file = tempo.item(0);
    if (this.extensiones.indexOf(file.type) < 0) {
      this.alertService.warn('Solo se permite archivos con extensión .jpg, .png', '/configuracion-camara', 'sin-codigo');
      return false;
    }
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => {
      if (flag === this.tipoContenido.logo) {
        this.logoUrl = reader.result.toString();
        this.logo_camara_file = file;
      } else {
        this.firmaUrl = reader.result.toString();
        this.firma_file = file;
      }
    };
  }

  enviarArchivo() {
    if (this.logo_camara_file) {
      const entryLogo = {
        codigo_camara: this.authService.getRolUser(RolesUsuario.AdministradorCC) ?
          this.authService.getCamaraUser() : this.formCamara.value.codigo_camara,
        contenido_certificado_id: 'LOGO_CAMARA',
        file_to_upload: this.logo_camara_file,
      };
      this.configurarCamara.uploadFile(entryLogo).subscribe(fileProgess => {
        if (fileProgess.type === HttpEventType.Response) {
          if (fileProgess.ok) {
            const resultado = fileProgess.body as ResponseServiceModel;
            if (resultado.result) {
              this.consultaLogoFirma();
              this.alertService
                .alert(resultado.control.alert_type as AlertType, 'Logo cargado exitosamente.',
                  `/ContenidoCertificadoAdministrador/SubirDocumento/${entryLogo.codigo_camara}/${entryLogo.contenido_certificado_id}`,
                  resultado.control.code.toString());
            } else {
              this.logo_camara_file = null;
              this.consultaLogoFirma();
            }
          }
        }
      });
    }

    if (this.firma_file || this.nombreFirmaAuxiliar != this.formFirma.get('nombre_firma').value) {
      const entryFirma = {
        codigo_camara: this.authService.getRolUser(RolesUsuario.AdministradorCC) ?
          this.authService.getCamaraUser() : this.formCamara.value.codigo_camara,
        contenido_certificado_id: 'FIRMA_RESPONSABLE_CERTIFICADO',
        file_to_upload: this.firma_file,
        nombre_firma: this.formFirma.value.nombre_firma
      };
      this.configurarCamara.uploadFile(entryFirma).subscribe(fileProgess => {
        if (fileProgess.type === HttpEventType.Response) {
          if (fileProgess.ok) {
            const resultado = fileProgess.body as ResponseServiceModel;
            if (resultado.result) {
              this.alertService
                .alert(resultado.control.alert_type as AlertType, 'Firma cargada exitosamente.',
                  `/ContenidoCertificadoAdministrador/SubirDocumento/${entryFirma.codigo_camara}/${entryFirma.contenido_certificado_id}`,
                  resultado.control.code.toString());
            } 
            this.consultaLogoFirma();
            this.firma_file = null;
          }
        }
      });
    }
  }

  ngOnDestroy() {
    URL.revokeObjectURL(this.firmaUrl)
  }
}

